import {api} from '../../../shared';
import {PartnersFilter, PartnersResponse, CreatePartnerDTO, PartnerModel, UpdatePartnerDTO} from '../model';

export const partnersApi = {
  getPartners: async (params: PartnersFilter = {}): Promise<PartnersResponse> => {
    const {pageSize = 25, after, ...restParams} = params;
    const queryParams = {
      ...restParams,
      includeTotalCount: true,
      first: pageSize,
      ...(after && {after}),
    };

    const {data} = await api.get<PartnersResponse>('/api/content/admin/project/partners', {params: queryParams});
    return data;
  },

  getPartnerById: async (partnerId: string): Promise<PartnerModel> => {
    const {data} = await api.get<PartnerModel>(`/api/content/admin/project/partners/${partnerId}`);
    return data;
  },

  createPartner: async (partner: CreatePartnerDTO): Promise<PartnerModel> => {
    const {data} = await api.post<PartnerModel>('/api/content/admin/project/partners', partner);
    return data;
  },

  updatePartner: async (partnerId: string, partner: UpdatePartnerDTO): Promise<PartnerModel> => {
    const {data} = await api.post<PartnerModel>(`/api/content/admin/project/partners/${partnerId}`, partner);
    return data;
  },

  updatePartnerLogo: async (partnerId: string, logoUploadId: string): Promise<void> => {
    await api.post(`/api/content/admin/project/partners/${partnerId}/logo`, {logoUploadId});
  },

  deletePartner: async (partnerId: string): Promise<void> => {
    await api.delete(`/api/content/admin/project/partners/${partnerId}`);
  },
};


